import React from 'react';

export default props => {
    return(
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.28 12.19" className={props.className}>
            <path d="M.17,12A.8.8,0,0,1,0,11.48a1.22,1.22,0,0,1,.06-.35,2.29,2.29,0,0,1,.12-.37L3.84.75A1.39,1.39,0,0,1,4.19.18a.65.65,0,0,1,.9,0,1.39,1.39,0,0,1,.35.57l3.66,10,.12.37a1.22,1.22,0,0,1,.06.35.8.8,0,0,1-.17.51.6.6,0,0,1-.47.2.8.8,0,0,1-.39-.09,1.75,1.75,0,0,1-.38-.3L4.72,8.68s-.06-.06-.08-.06,0,0-.08.06L1.41,11.8a2,2,0,0,1-.39.3.79.79,0,0,1-.38.09A.59.59,0,0,1,.17,12Z"/>
        </svg>
    );
}